import { render, staticRenderFns } from "./createTime.vue?vue&type=template&id=68674e09&"
import script from "./createTime.vue?vue&type=script&lang=js&"
export * from "./createTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/system/createTime.vue"
export default component.exports